/**
 * Extrai a imagem principal de qualquer estrutura de imagens
 * Suporta: array simples, objeto com { main, colors }
 */
export function getMainImage(images: any): string {
    const PLACEHOLDER = '../assets/images/placeholder.jpg';
    
    if (!images) return PLACEHOLDER;
    
    // Se for string, tentar parsear JSON
    if (typeof images === 'string') {
        try {
            images = JSON.parse(images);
        } catch (e) {
            return PLACEHOLDER;
        }
    }
    
    // Se for objeto com estrutura { main, colors }
    if (typeof images === 'object' && !Array.isArray(images) && images.main) {
        return images.main && images.main.trim() !== '' ? images.main : PLACEHOLDER;
    }
    
    // Se for array
    if (Array.isArray(images) && images.length > 0) {
        const firstImage = images[0];
        if (firstImage && typeof firstImage === 'string' && firstImage.trim() !== '') {
            return firstImage;
        }
    }
    
    return PLACEHOLDER;
}

/**
 * Extrai a imagem por cor de uma estrutura de imagens
 * Retorna a imagem principal se não houver imagem para a cor específica
 */
export function getImageByColor(images: any, color: string): string {
    const mainImage = getMainImage(images);
    
    if (!images || !color) return mainImage;
    
    // Se for string, tentar parsear JSON
    if (typeof images === 'string') {
        try {
            images = JSON.parse(images);
        } catch (e) {
            return mainImage;
        }
    }
    
    // Se for objeto com estrutura { main, colors }
    if (typeof images === 'object' && !Array.isArray(images) && images.colors) {
        const colorImage = images.colors[color];
        if (colorImage && colorImage.trim() !== '') {
            return colorImage;
        }
    }
    
    // Se não encontrou imagem específica da cor, retorna a principal
    return mainImage;
}

/**
 * Verifica se a estrutura de imagens tem imagens por cor
 */
export function hasColorImages(images: any): boolean {
    if (!images) return false;
    
    // Se for string, tentar parsear JSON
    if (typeof images === 'string') {
        try {
            images = JSON.parse(images);
        } catch (e) {
            return false;
        }
    }
    
    // Se for objeto com estrutura { main, colors }
    if (typeof images === 'object' && !Array.isArray(images) && images.colors) {
        return Object.keys(images.colors).length > 0;
    }
    
    return false;
}

/**
 * Retorna todas as cores que têm imagens específicas
 */
export function getAvailableColorImages(images: any): string[] {
    if (!images) return [];
    
    // Se for string, tentar parsear JSON
    if (typeof images === 'string') {
        try {
            images = JSON.parse(images);
        } catch (e) {
            return [];
        }
    }
    
    // Se for objeto com estrutura { main, colors }
    if (typeof images === 'object' && !Array.isArray(images) && images.colors) {
        return Object.keys(images.colors);
    }
    
    return [];
}

